import { TRANS_WEBP_STR } from '@commonPackage/components';
import { EN, LANG_LOCAL_STORAGE_KEY } from '@yaotai/common-utils';

export const YAOTAI_LOGO = `https://static.fuxi.netease.com/yaotai/portal/20220609/l470lyei_logo-white.png?${TRANS_WEBP_STR}`;
export const YAOTAI_LOGO_EN = `https://static.fuxi.netease.com/yaotai/portal/20220609/l470luj1_logo-white-en.png?${TRANS_WEBP_STR}`;
export const YAOTAI_LOGO_BLACK = `https://static.fuxi.netease.com/yaotai/portal/20220628/l4xxkqd5_logo组合-横版@2x.png?${TRANS_WEBP_STR}`;
export const YAOTAI_LOGO_BLACK_EN = `https://static.fuxi.netease.com/yaotai/portal/20220609/l46t3owl_logo-black-en.png?${TRANS_WEBP_STR}`;

export const INITIAL_PORTAL_INDEX_URL = `${
  window.localStorage.getItem(LANG_LOCAL_STORAGE_KEY) === EN ? `/${EN}/` : `/`
}`;

export const QUESTIONS_DETAIL_BANNER = `https://static.fuxi.netease.com/yaotai/portal/20220721/l5v07k6f_161894.jpg?${TRANS_WEBP_STR}`;

// 这里的定义存在部分冗余，存在 label 和 href 共存
// 部分为 label，和路径没有强关联，主要是名称展示和国际化
export enum RouterConfigEnum {
  AboutUs = 'aboutUs',
  AcademicConference = 'academicConference',
  ActivityCenter = 'activity/center',
  ActivityConsult = 'activityConsult',
  AdMetaH5 = 'ad-meta-h5',
  Additional = 'material-additional',
  Advice = 'advice',
  AgentApply = 'agent/apply',
  AgentPage = 'agent',
  AnnualMeeting = 'annual-meeting',
  AnnualMeetingH5 = 'annual-meeting-h5',
  AnnualMeetingH5Success = 'h5-success',
  ArtShow = 'artShow',
  AuthorizedAgent = 'authorizedAgent',
  AutoShow = 'autoShow',
  CarShow = 'carShow',
  Museum = 'museum',
  CorporateSpace = 'corporate-space',
  CommonContact = 'common/contact/:contactType',
  CommonContactActivity = 'common/contact/activity',
  CommonContactAgent = 'common/contact/agent',
  CommonContactCooperation = 'common/contact/cooperation',
  CommonContactSlug = 'common/contact',
  Consult = 'about/consult',
  ContactUs = 'about/contact/:contactType',
  ContactUsActivity = 'about/contact/activity',
  ContactUsAgent = 'about/contact/agent',
  ContactUsCooperation = 'about/contact/cooperation',
  ContactUsPage = 'contactUs', //
  ContactUsSlug = 'about/contact',
  CoreTechnology = 'core-technology',
  CustomerService = 'customerService',
  Daka = 'daka',
  Database = 'database',
  DatabaseListNews = 'databaseList.news',
  DownloadWay = 'activityCenter/download',
  EcologicalCooperation = 'ecologicalCooperation',

  EventEntrance = 'activity/entrance',
  HelpCenter = 'help',
  HelpCenterLabel = 'helpCenter',
  Home = 'home',
  IndustrialReports = 'industrial-reports',
  IndustryReports = 'industryReports',

  IndustrySummit = 'industrySummit',
  KnowUs = 'about/knowUs',
  Learning = 'learning',
  Manual = 'manual',
  Marketing = 'Marketing',
  MarketingSucPage = 'marketing-suc',
  Media = 'media',
  News = 'news',
  ProductFeature = 'product',
  ProductTraining = 'productTraining',
  Question = 'question',
  Recommend = 'recommend',
  Scenario = 'scenario',
  Scene = 'scene',
  SceneCase = 'scene-case/:id',
  SceneCaseArtShow = 'scene-case/artShow',
  SceneCaseCarShow = 'scene-case/carShow',
  SceneCaseIndustrySummit = 'scene-case/industrySummit',
  SceneCaseLearning = 'scene-case/learning',
  SceneCaseMuseum = 'scene-case/museum',
  SceneCaseCorporateSpace = 'scene-case/corporate-space',
  SceneCasePre = 'scene-case',
  SeoMaterialDaka = 'cs/material/daka',
  SeoMaterialIndustrialReport = 'cs/material/industrial-reports',
  SeoMaterialSlug = 'cs/material',

  SeoMaterialSuccessfulCase = 'cs/material/successful-cases',
  SeoPostSlug = 'cs/news',
  SeoQuestionSlug = 'cs/metaverse',
  SuccessCase = 'successCase',
  UnderstandUs = 'understandUs',
  VideoTraining = 'videoTraining',
  VirtualActivity = 'virtualActivity',
  WhyChooseYaotai = 'whyChooseYaotai',
  Yaotai = 'yaotai',
  YaotaiListCoreTechnology = 'yaotaiList.coreTechnology',
}

export const PORTAL_NO_AUTH_URL = window.origin;
